import { useState, useEffect } from 'react';
import { useAllInOneContext } from '../context';

export default function checkListsExist() {
  const { lists } = useAllInOneContext();
  const [listsExist, setListsExist] = useState(false);

  useEffect(() => {
    if (lists) {
      if (lists.length > 0) setListsExist(true);
      else setListsExist(false);
    }
  }, [lists]);

  return { listsExist };
}
